<template>
	<div v-loading='loading'>
		<el-row :gutter="25" class="container">
			<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="ho_til2" v-for="(item,index) in navList">
				<div class="ho_top">
					<h3>{{item.title}}</h3>
					<router-link v-if="item.list_type==1" :to="`/rules?id=${item.id}&name=${item.title}`">更多></router-link>
					<router-link v-else :to="`/news?id=${item.id}&name=${item.title}`">更多></router-link>
				</div>
				<div style="width: 100%;display: flex;justify-content: space-between;align-items: center;">
					<el-col class="news">
						<ul class="jjbq-box">
							<li class="clearfix" v-for="(child,cindex) in item.news">
								<div class="news-box">
									<h3>
										<router-link class="time4"
											:to="`/newsdetail?id=${child.id}`">{{child.title}}</router-link>
									</h3>
									<span>{{child.created_at | time}}</span>
								</div>
							</li>
						</ul>
					</el-col>
				</div>
			</el-col>
		</el-row>
	</div>
</template>
<script>
	import 'bootstrap/dist/js/bootstrap.js'
	import 'bootstrap/dist/css/bootstrap.min.css'
	import 'bootstrap/dist/js/bootstrap.min'
	import {
		Adv
	} from '@/api/adv';
	var adv = new Adv();
	import moment from '@/utils/moment'
	export default {
		data() {
			return {
				loading: false,
				navList: [],
			}
		},
		created() {
			this.loading = true;
			this.getNavBar();
		},
		filters: {
			// 时间格式化
			time(val) {
				return moment(val * 1000).format('YYYY-MM-DD');
			},
		},
		methods: {
			//分类带内容列表
			getNavBar() {
				var that = this;
				var param = {};
				this.loading = false;
				adv.cate(param).then(data => {
					that.navList = that.navList.concat(data.data);
				}).catch((res) => {

				});
			},
		}
	};
</script>
<style scoped>
	.container {
		margin: 20px auto !important;
	}

	.ho_til2 {
		width: 100%;
		padding: 0 !important;
	}

	.ho_top {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		background: #2c3096;
		color: #fff;
		padding: 8px;
		margin-bottom: 15px;
		border-radius: 5px;
	}

	.ho_til2 h3 {
		color: #fff;
		font-size: 16px;
		font-weight: 700;
		display: inline-block;
		margin-bottom: 0 !important;
	}

	.ho_til2 a {
		color: #fff !important;
	}

	.news ul {
		padding: 0 5px;
	}

	.jjbq-box {
		position: relative;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-ms-flex-wrap: wrap;
		flex-wrap: wrap;
	}

	.news li {
		width: 100%;
		-ms-flex: 0 0 100%;
		flex: 0 0 100%;
		max-width: 100%;
		height: 34px;
		border-bottom: 1px dashed #d1d1d1;
	}

	.jjbq-box li {
		-webkit-box-flex: 0;
	}

	li {
		list-style: none;
	}

	.news {
		padding-left: 0 !important;
		padding-right: 0 !important;
	}

	.news .news-box {
		position: relative;
		padding-left: 12px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		color: #fff !important;
	}

	.news .news-box h3 {
		color: #444444;
		font-size: 14px;
		line-height: 34px;
		display: inline-block;
		width: 70%;
	}

	.news .news-box h3 a {
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
		overflow: hidden;
		line-height: 33px;
		height: 33px;
		word-break: break-all;
		color: #333 !important;
	}

	.news .news-box span {
		color: #666666;
		font-size: 14px;
		font-weight: 400;
		line-height: 34px;
		float: right;
	}

	.news .news-box::before {
		content: "";
		position: absolute;
		left: 0;
		top: 16px;
		border-radius: 10px;
		width: 4px;
		height: 4px;
		background: #2c3096;
	}
</style>